module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-2.svg";